import { DeviceFilters } from "../types/filters";

export function buildQueryParams(filters: DeviceFilters): string {
    const params = new URLSearchParams();

    // 1. Search Query
    if (filters.q) {
        params.set("q", filters.q);
    }

    // 2. Multi-select Strings (Brands, SIM, Memory, Biometrics)
    // We join them with commas to match your Rails .split(',') logic
    const stringKeys: (keyof DeviceFilters)[] = ["brands", "memory_slot", "sim_type", "biometrics"];
    stringKeys.forEach(key => {
        const val = filters[key] as string[];
        if (val?.length) {
            params.set(key, val.join(","));
        }
    });

    // 3. Ranges (number[][])
    // Converts [[0, 5], [10, 20]] into "0-5,10-20"
    const rangeKeys: (keyof DeviceFilters)[] = [
        "screen_size", "ram", "storage", "refresh_rate",
        "release_year", "main_camera", "front_camera"
    ];

    rangeKeys.forEach(key => {
        const ranges = filters[key] as number[][];
        if (ranges?.length) {
            // Join inner pair with '-', then join all pairs with ','
            params.set(key, ranges.map(r => r.join("-")).join(","));
        }
    });

    // 4. Booleans (5G, NFC, Charging)
    const boolKeys: (keyof DeviceFilters)[] = [
        "has_5g", "has_nfc", "fast_charging", "wireless_charging"
    ];

    boolKeys.forEach(key => {
        if (filters[key] === true) {
            params.set(key, "true");
        }
    });

    return params.toString();
}